import Edit from './component';

export default Edit;
